import React from "react";
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from "../../../util/IntlMessages";
import AllPlayerTable from "./components/AllPlayerTable";
import ContainerHeader from '../../../components/ContainerHeader'
import {
    getAllPlayers,
    getAllPlayersSuccess
} from '../../../actions/PlayerAction';
import Report from '../user/routes/report'

class Players extends React.Component {
    constructor() {
        super()
        this.state = {
            showModal: false
        }
    }

    componentDidMount() {
        const sessionToken = this.props.auth.authUser.sessionToken;
        const allPlayers = this.props.allPlayers;
        if (allPlayers === null || allPlayers.length === 0) {
            this.props.getAllPlayers({ sessionToken });
        }
    }

    render() {

        return (
            <div className="app-wrapper">
                <div className="dashboard animated slideInUpTiny animation-duration-3">
                    {/* <div style={{ padding: '20px 20px 20px 20px' }} className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center ">
                        <h2 className="title mb-3 mb-sm-0">{<IntlMessages id="players.title" />}</h2>
                    </div> */}
                    <ContainerHeader
                        match={this.props.match}
                        title={<IntlMessages id="players.title" />}
                    />
                    <div className="row">
                        <div className="col-lg-12 col-sm-12 col-12">
                            {this.props.allPlayerLoader ? (
                                <div>
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 130 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                </div>
                            ) : (
                                    <AllPlayerTable
                                        playersStoreData={this.props.allPlayers}
                                    />
                                )}
                        </div>
                    </div>
                </div>
                {/* <NotificationContainer /> */}
                <Switch>
                    <Route path={`${this.props.match.url}/report`} component={Report} />
                </Switch>
            </div>
        );
    }

}

const mapStateToProps = ({ settings, player, auth }) => {
    const { width, drawerType, navigationStyle, horizontalNavPosition } = settings;
    const { allPlayers, allPlayerLoader } = player;
    return { width, drawerType, navigationStyle, horizontalNavPosition, allPlayers, allPlayerLoader, auth }
}
export default withRouter(connect(mapStateToProps, {
    getAllPlayers,
    getAllPlayersSuccess
})(Players));
